var NPDIRegistrationService = function () {
    var pecByPass = false;

    this.getPecByPass = function () {
        return pecByPass;
    };

    this.setPecByPass = function (data) {
        pecByPass = data;
    };
};

export default NPDIRegistrationService;
